import { useAtomValue } from 'jotai';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useGetOrderDetails } from '../../api/useGetOrderDetails';
import { orderDetailsDrawerAtom } from '../../atoms/orderDetailsDrawerAtoms';
import {
	FulfillmentTypeCell,
	OrderDateCell,
	OrderTabCell,
	PaymentChoiceCell,
} from '../table-cells';
import { FinancingStatusTag } from '../table-cells/shared/FinancingStatusTag';
import { PaymentStatusTag } from '../table-cells/shared/PaymentStatusTag';

import { SectionSkeleton } from './shared/SectionSkeleton';

const SECTION_TITLE = 'Overview';

export const OverviewSection = () => {
	const { selectedRow } = useAtomValue(orderDetailsDrawerAtom);
	const { data: orderDetails, isLoading } = useGetOrderDetails(
		selectedRow?.purchasedVehicleId || undefined,
	);

	if (isLoading) {
		return <SectionSkeleton title={SECTION_TITLE} />;
	}

	if (!orderDetails) {
		return null;
	}

	const { overview } = orderDetails;

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<Stack itemsSpacing='16'>
				<InfoLineItem
					title='Order stage'
					content={<OrderTabCell tab={overview.tabLabel} />}
				/>
				{overview.cancelationReason && (
					<InfoLineItem title='Cancelation reason' value={overview.cancelationReason} />
				)}
				<InfoLineItem
					title='Order date'
					content={<OrderDateCell date={overview.orderDate} />}
				/>
				<InfoLineItem
					title='Payment choice'
					content={<PaymentChoiceCell paymentChoice={overview.paymentChoice} />}
				/>
				<InfoLineItem
					title='Payment status'
					content={<PaymentStatusTag status={overview.paymentStatus} />}
				/>
				<InfoLineItem
					title='Financing status'
					content={<FinancingStatusTag status={overview.financingStatus} />}
				/>
				<InfoLineItem
					title='Fulfillment type'
					content={<FulfillmentTypeCell fulfillmentType={overview.fulfillmentType} />}
				/>
			</Stack>
		</AccordionSection>
	);
};
